import React from 'react';
import BottleLoadingImage from 'images/bottle-loading-image.jpg';
import BottleLoadingImageLarge from 'images/bottle-loading-image-large.jpg';

export default class ProductImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { large, loading, className, alt, title, itemProp } = this.props;
    const product = this.props.product || {};
    const imageSrc = large ? product.image_large : product.image;
    const fallbackSrc = large ? BottleLoadingImageLarge : BottleLoadingImage;
    const src =
      loading || this.state.hasError || !imageSrc ? fallbackSrc : imageSrc;

    return (
      <img
        className={className}
        alt={alt || undefined}
        itemProp={itemProp || undefined}
        title={title}
        src={src}
        onError={() => this.setState({ hasError: true })}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/ui/productImage/index.js